module.exports = __webpack_public_path__ + "static/media/ban.7a2e550a.jpg";